import { render, staticRenderFns } from "./ButtonCointracker.vue?vue&type=template&id=ff990c3a&"
import script from "./ButtonCointracker.vue?vue&type=script&lang=js&"
export * from "./ButtonCointracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports